import React from "react";
import { ChannelContext } from "../contexts";
import "../assets/styles/footer_links.sass";
import Utility from "../Utility";
import { Link } from "react-router-dom";
const FooterLinks = ({ content }) => {
  const linksList = (
    <ChannelContext.Consumer>
      {(currentChannel) => {
        const linksList = Utility.getChannelFooterLinks(
          content,
          currentChannel
        );
        if (!linksList || linksList.length === 0) return null;
        return linksList.map((link, index) => (
          <Link key={index} to={link.url} className="ur-mini-footer-link">
            {link.title}
          </Link>
        ));
      }}
    </ChannelContext.Consumer>
  );
  return <div className="ur-mini-footer-links">{linksList}</div>;
};
export default FooterLinks;
